<template>


    <!-- TOAST -->
    <div
      v-if="mostrarToast"
      class="toast-container position-fixed top-0 end-0 p-3"
      style="z-index: 1055;"
    >
      <div class="toast show align-items-center text-white" :class="toastColor">
        <div class="d-flex">
          <div class="toast-body">
            <i :class="iconoToast" class="me-2"></i> {{ alerta.mensaje }}
          </div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
        </div>
      </div>
    </div>

    <!-- Sección para generar un nuevo código -->
    <div class="card p-4 shadow-sm mb-4">
      <h5 class="mb-3 text-center" >Generar Código de Descuento</h5>

      <!-- Tipo de Cupón -->
      <div class="mb-3">
        <label class="form-label fw-semibold">Tipo de Cupón</label>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="tipoMonto"
            value="monto"
            v-model="tipoCupon"
          >
          <label class="form-check-label" for="tipoMonto">
            Monto Específico
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="tipoCortesia"
            value="cortesia"
            v-model="tipoCupon"
          >
          <label class="form-check-label" for="tipoCortesia">
            Cortesía de Pago Total (100%)
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="tipoPersistente"
            value="persistente"
            v-model="tipoCupon"
          >
          <label class="form-check-label" for="tipoPersistente">
            Persistente (uso múltiple con límite diario)
          </label>
        </div>
      </div>

      <!-- Monto del descuento (para monto y persistente) -->
      <div v-if="tipoCupon === 'monto' || tipoCupon === 'persistente'" class="mb-3">
        <label class="form-label">{{ tipoCupon === 'persistente' ? 'Descuento por producto (Q)' : 'Monto del Descuento (Q)' }}</label>
        <input
          type="number"
          v-model="MontoDescuento"
          class="form-control"
          min="1"
          step="0.01"
          placeholder="Ingrese el monto del descuento"
        />
      </div>

      <!-- Límite diario (solo persistente) -->
      <div v-if="tipoCupon === 'persistente'" class="mb-3">
        <label class="form-label">Límite de usos por día</label>
        <input
          type="number"
          v-model.number="LimiteDiario"
          class="form-control"
          min="1"
          step="1"
          placeholder="Máximo de veces que se puede usar al día"
        />
      </div>

      <!-- Alerta de persistente -->
      <div v-if="tipoCupon === 'persistente'" class="alert alert-info">
        <i class="bi bi-info-circle-fill me-2"></i>
        <strong>Cupón Persistente:</strong> Este cupón no se vence después de usarse y se podrá usar hasta {{ LimiteDiario || '∞' }} veces por día.
      </div>

      <!-- Alerta de cortesía -->
      <div v-if="tipoCupon === 'cortesia'" class="alert alert-warning">
        <i class="bi bi-exclamation-triangle-fill me-2"></i>
        <strong>Cortesía Total:</strong> Este cupón pagará el 100% de la cuenta sin importar el monto.
      </div>

      <div class="mb-3">
        <label class="form-label">Descripción del Uso</label>
        <textarea
          v-model="DescripcionUso"
          class="form-control"
          placeholder="Describa el uso de este código"
          rows="2"
        ></textarea>
      </div>

      <div class="text-center mt-3">
        <button
          class="btn btn-success"
          @click="generarCodigo"
          :disabled="cargando || !DescripcionUso || (tipoCupon === 'monto' && !MontoDescuento) || (tipoCupon === 'persistente' && (!MontoDescuento || !LimiteDiario))"
        >
          {{ cargando ? 'Generando...' : 'Generar Código' }}
        </button>
      </div>
    </div>

    <!-- Sección para listar los códigos generados -->
    <div class="card p-4 shadow-sm">
      <h5 class="mb-3">Códigos Generados</h5>

      <div class="table-responsive">
        <table class="table table-bordered table-hover text-center">
          <thead class="table-light">
            <tr>

              <th>Código</th>
              <th>Descripcion Uso</th>
              <th>Tipo</th>
              <th>Monto Descuento (Q)</th>
              <th>Estado</th>
              <th>Fecha Creación</th>
              <th>Creado por:</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="codigos.length === 0">
              <td colspan="8">No hay códigos generados.</td>
            </tr>
            <tr v-for="codigo in codigos" :key="codigo.IdCodigo">

              <td>{{ codigo.Codigo }}</td>
              <td>{{ codigo.DescripcionUso }}</td>
              <td>
                <span v-if="codigo.Persistente" class="badge bg-primary">
                  🔄 Persistente
                  <span v-if="codigo.LimiteDiario" class="d-block small">
                    ({{ codigo.LimiteDiario }}/día)
                  </span>
                </span>
                <span v-else-if="codigo.MontoDescuento === -1" class="badge bg-info">
                  🎁 Cortesía
                </span>
                <span v-else class="badge bg-secondary">
                  Normal
                </span>
              </td>
              <td>
                <span v-if="codigo.MontoDescuento === -1" class="badge bg-info">
                  🎁 Cortesía 100%
                </span>
                <span v-else>
                  Q.{{ Number(codigo.MontoDescuento).toFixed(2) }}
                </span>
              </td>
              <td>
                <span v-if="codigo.Persistente" class="badge bg-success">
                  Activo
                </span>
                <span v-else :class="codigo.Estado ? 'badge bg-secondary' : 'badge bg-success'">
                  {{ codigo.Estado ? 'Usado' : 'Disponible' }}
                </span>
              </td>
              <td>{{ codigo.FechaCreacion }}</td>
              <td>{{ codigo.empleado?.Nombres }} {{ codigo.empleado?.Apellidos }}</td>
              <td>
                <button
                  class="btn btn-sm btn-primary me-1"
                 :disabled="!codigo.Persistente && codigo.Estado === 1"
                  @click="copiarCodigo(codigo.Codigo)"
                >
                  Copiar
                </button>
                <button
                  class="btn btn-sm btn-danger"
                 :disabled="!codigo.Persistente && codigo.Estado === 1"
                  @click="eliminarCodigo(codigo)"
                >
                  Eliminar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal Confirmar Eliminación -->
    <div v-if="mostrarModalEliminar" class="modal-backdrop" @click.self="cerrarModalEliminar">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Confirmar Eliminación</h5>
          <button type="button" class="btn-close" @click="cerrarModalEliminar"></button>
        </div>
        <div class="modal-body">
          <p>¿Estás seguro de que deseas eliminar este código de descuento?</p>
          <p class="text-warning mt-2">
            <i class="bx bx-info-circle"></i>
            <strong>Código:</strong> {{ codigoAEliminar?.Codigo }} -
            <span v-if="codigoAEliminar?.MontoDescuento === -1" class="badge bg-info">🎁 Cortesía 100%</span>
            <span v-else>Q{{ Number(codigoAEliminar?.MontoDescuento).toFixed(2) }}</span>
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="cerrarModalEliminar">Cancelar</button>
          <button type="button" class="btn btn-danger" @click="confirmarEliminacion">
            <i class="bx bx-trash"></i> Eliminar
          </button>
        </div>
      </div>
    </div>

</template>

<script>
import axios from 'axios'
import { API_URL } from '@/config/config.js'
import { mapGetters } from 'vuex'

export default {
  name: 'GestionCodigosDescuento',
  data() {
    return {
      tipoCupon: 'monto', // 'monto', 'cortesia' o 'persistente'
      MontoDescuento: '',
      LimiteDiario: '',
      DescripcionUso:'',
      cargando: false,
      codigos: [],
      alerta: { mensaje: '', tipo: 'success' },
      mostrarToast: false,
      mostrarModalEliminar: false,
      codigoAEliminar: null
    }
  },
  computed: {
    ...mapGetters(['getUser']),
    toastColor() {
      return this.alerta.tipo === 'success' ? 'bg-success' : 'bg-danger';
    },
    iconoToast() {
      return this.alerta.tipo === 'success' ? 'bi bi-check-circle-fill' : 'bi bi-x-circle-fill';
    }
  },
  async mounted() {
    await this.obtenerCodigos();
  },
  methods: {
    async generarCodigo() {
      this.cargando = true;
      this.mostrarToast = false;

      try {
        // Si es cortesía total, enviar -1 como monto
        const monto = this.tipoCupon === 'cortesia' ? -1 : this.MontoDescuento;

        const payload = {
          MontoDescuento: monto,
          DescripcionUso: this.DescripcionUso,
          IdEmpleado: this.getUser.IdEmpleado,
          Persistente: this.tipoCupon === 'persistente' ? 1 : 0,
        };

        if (this.tipoCupon === 'persistente' && this.LimiteDiario) {
          payload.LimiteDiario = this.LimiteDiario;
        }

        await axios.post(`${API_URL}/crear-codigo`, payload);

        this.mostrarAlerta('Código generado correctamente.', 'success');
        this.MontoDescuento = '';
        this.LimiteDiario = '';
        this.DescripcionUso = '';
        this.tipoCupon = 'monto';
        await this.obtenerCodigos();
      } catch (error) {
        console.error('Error al generar el código:', error);
        this.mostrarAlerta('Hubo un error al generar el código.', 'danger');
      } finally {
        this.cargando = false;
      }
    },
    async obtenerCodigos() {
      try {
        const response = await axios.get(`${API_URL}/crear-codigo`);
        this.codigos = response.data.codigos;
      } catch (error) {
        console.error('Error al obtener los códigos:', error);
        this.mostrarAlerta('Hubo un error al cargar los códigos.', 'danger');
      }
    },
    mostrarAlerta(mensaje, tipo) {
      this.alerta.mensaje = mensaje;
      this.alerta.tipo = tipo;
      this.mostrarToast = true;
      setTimeout(() => {
        this.mostrarToast = false;
      }, 3000);
    },
    cerrarToast() {
      this.mostrarToast = false;
    },
    eliminarCodigo(codigo) {
      this.codigoAEliminar = codigo;
      this.mostrarModalEliminar = true;
    },
    cerrarModalEliminar() {
      this.mostrarModalEliminar = false;
      this.codigoAEliminar = null;
    },
    async confirmarEliminacion() {
      if (!this.codigoAEliminar) return;

      try {
        await axios.delete(`${API_URL}/crear-codigo/${this.codigoAEliminar.IdCodigo}`);
        this.mostrarAlerta('Código eliminado correctamente.', 'success');
        this.cerrarModalEliminar();
        await this.obtenerCodigos();
      } catch (error) {
        console.error('Error al eliminar el código:', error);
        this.mostrarAlerta(
          error.response?.data?.message || 'Error al eliminar el código.',
          'danger'
        );
        this.cerrarModalEliminar();
      }
    },
  copiarCodigo(codigo) {
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(codigo)
      .then(() => {
        this.mostrarAlerta(`Código "${codigo}" copiado al portapapeles.`, 'success');
      })
      .catch(() => {
        this.mostrarAlerta('Error al copiar el código.', 'danger');
      });
  } else {
    // Fallback para contextos inseguros como IP local
    const textarea = document.createElement("textarea");
    textarea.value = codigo;
    textarea.style.position = "fixed"; // Evita desplazamiento
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    try {
      const exito = document.execCommand('copy');
      if (exito) {
        this.mostrarAlerta(`Código "${codigo}" copiado al portapapeles.`, 'success');
      } else {
        this.mostrarAlerta('No se pudo copiar el código.', 'danger');
      }
    } catch (err) {
      this.mostrarAlerta('Error al copiar el código.', 'danger');
    }
    document.body.removeChild(textarea);
  }
}
  }
}
</script>

<style scoped>
.container {
  max-width: 800px;
}
.table td,
.table th {
  vertical-align: middle;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modal-content {
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  max-width: 500px;
  width: 90%;
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header {
  padding: 1.25rem;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-title {
  margin: 0;
  font-weight: 600;
  font-size: 1.25rem;
}

.modal-body {
  padding: 1.25rem;
}

.modal-footer {
  padding: 1.25rem;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.btn-close {
  background: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  opacity: 0.5;
}

.btn-close:hover {
  opacity: 1;
}
</style>
